import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeSuiReport extends Layout {
    checkboxIncludeSettlement: Checkbox;
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceSuiReports: DataSource;
    textboxDateRange: Textbox;
}
